module.exports = __webpack_public_path__ + "img/gamechanger-bolt.75e3ddfe.svg";